export * from "./message/public";
export * from "./pagination/public";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/public.js
// module id = 1085
// module chunks = 0